import Base from "./Base";

class Packs extends Base {
    static savePack(params) {
        return this.sendRequest('/packs/save-pack', 'POST', params);
    }

    static getPackLists(params) {
        return this.sendRequest('/items/get-children-items', 'POST', params);
    }

    static deletePack(params) {
        return this.sendRequest('/packs/delete-pack', 'POST', params);
    }

    static changeSheetsOrder(params) {
        return this.sendRequest('/packs/change-sheets-order', 'POST', params);
    }

    static addSheet(params) {
        return this.sendRequest('/packs/add-sheet', 'POST', params);
    }

    static importStatus(params) {
        return this.sendRequest('/list/import-status', 'POST', params);
    }

    static importExcelSheetWithDefaultOptions(body) {
        return this.sendRequest('/import/import-excel-sheet-with-default-options', 'POST', {}, body, true, true);
    }

    static removeSheet(params) {
        return this.sendRequest('/packs/remove-sheet', 'POST', params);
    }

    static deleteItem(params) {
        return this.sendRequest('/items/delete-item', 'POST', params);
    }

    static getExportTemplate(params) {
        return this.sendRequest('/packs/get-export-template', 'POST', params);
    }

    static exportTemplate(params) {
        return this.sendRequest('/packs/export-template', 'POST', params);
    }

    static checkExportStatus(params) {
        return this.sendRequest('/packs/check-export-status', 'POST', params);
    }

    static importTemplate(params) {
        return this.sendRequest('/packs/import-template', 'POST', params);
    }

    static checkImportStatus(params) {
        return this.sendRequest('/packs/check-import-status', 'POST', params);
    }

    static installTemplate(params) {
        return this.sendRequest('/packs/install-template', 'POST', params);
    }

    static getPacks(params) {
        return this.sendRequest('/packs/get-packs', 'GET', params);
    }

    static getPack(params) {
        return this.sendRequest('/packs/get-pack', 'POST', params);
    }

    static  duplicateSheet(body) {
        return this.sendRequest('/packs/duplicate-sheet', 'POST',{}, body);
    }

    static getPackBySheetId(params) {
        return this.sendRequest('/packs/get-pack-by-sheet-id', 'POST', params);
    }
}

export default Packs;